import { defaultFont } from "assets/jss/material-kit-react.js";

import tooltip from "assets/jss/material-kit-react/tooltipsStyle.js";

const headerLinksStyle = (theme) => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "inherit",
    backgroundColor: "#fff",
  },
  listItem: {
    float: "none",
    color: "#333",
    position: "relative",
    display: "block",
    width: "100%",
    margin: "0 5px",
    padding: "0",
    [theme.breakpoints.up("md")]: {
      float: "left",
      width: "auto",
      margin: "0",
    },
  },
  listItemText: {
    padding: "0 !important",
  },
  navLink: {
    color: "#333",
    position: "relative",
    padding: "10px 20px",
    fontWeight: "400",
    fontSize: "13px",
    textTransform: "none",
    borderRadius: "2px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0",
    display: "block",
    transition: "all 150ms linear",
    "&:hover,&:focus": {
      backgroundColor: "#f5f5f5",
      color: "#333",
    },
    [theme.breakpoints.up("md")]: {
      color: "inherit",
      padding: "0.9375rem",
      fontSize: "12px",
      textTransform: "uppercase",
      display: "inline-flex",
      "&:hover,&:focus": {
        color: "inherit",
        background: "rgba(200, 200, 200, 0.2)",
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 10px)",
      marginLeft: "0",
      marginBottom: "2px",
      marginTop: "2px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start",
      },
    },
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px",
  },
  registerNavLink: {
    top: "3px",
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  icons: {
    width: "20px",
    height: "20px",
    marginRight: "3px",
  },
  socialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px",
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px",
    },
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px",
  },
});

export default headerLinksStyle;

export const sideHeaderLink = () => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "inherit",
    backgroundColor: "#fff",
  },
  listItem: {
    float: "none",
    color: "#333",
    position: "relative",
    display: "block",
    width: "100%",
    margin: "0 5px",
    padding: "0",
  },
  listItemText: {
    padding: "0 !important",
  },
  navLink: {
    color: "#333",
    position: "relative",
    padding: "12px 20px",
    fontWeight: "500",
    fontSize: "14px",
    textTransform: "none",
    borderRadius: "6px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "4px 8px",
    display: "block",
    transition: "all 150ms linear",
    "&:hover,&:focus": {
      backgroundColor: "#f5f5f5",
      color: "#333",
    },
    width: "calc(100% - 16px)",
    marginLeft: "8px",
    marginRight: "8px",
    marginBottom: "4px",
    marginTop: "4px",
    textAlign: "left",
    "& > span:first-child": {
      justifyContent: "flex-start",
    },
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px",
  },
  registerNavLink: {
    top: "3px",
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  icons: {
    width: "20px",
    height: "20px",
    marginRight: "3px",
  },
  socialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px",
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px",
    },
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px",
  },
})
